import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Link from 'react-router-dom';
import { FiClock, FiPhoneIncoming, FiPhoneOutgoing, FiDollarSign } from 'react-icons/fi';
import { auth as firebaseAuth } from '../../firebase/config';
import SEO from '../layout/SEO';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const CallHistory = ({ user, session }) => {
    const [calls, setCalls] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const headers = user?.isGuest
                    ? { 'x-session-id': session }
                    : { 'Authorization': `Bearer ${await firebaseAuth.currentUser?.getIdToken()}` };

                const res = await axios.get(`${API_URL}/calls/history`, { headers });
                setCalls(res.data.calls || []);
            } catch (err) {
                console.error('Failed to load history', err);
            } finally {
                setLoading(false);
            }
        };
        if (user) fetchHistory();
    }, [user, session]);

    if (loading) return <p>Loading history...</p>;

    return (
        <div className="animate-fade">
            <SEO
                title="Your Call History & Usage Records"
                description="View your international call history, duration, and costs. Transparency is our priority."
                canonical="/history"
            />
            <h1>Call History</h1>
            {user?.isGuest && (
                <div className="card" style={{ marginBottom: '2rem', borderLeft: '4px solid var(--warning)', background: 'rgba(245, 158, 11, 0.05)' }}>
                    <p style={{ color: 'var(--warning)', fontWeight: 600 }}>Guest Mode</p>
                    <p style={{ fontSize: '0.875rem' }}>History is temporary. Sign in to sync your logs permanently.</p>
                </div>
            )}

            <div className="card">
                {calls.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '3rem' }}>
                        <FiClock size={48} color="var(--border)" />
                        <p style={{ marginTop: '1rem' }}>No calls yet. Start calling to see logs.</p>
                    </div>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '1px solid var(--border)', color: 'var(--text-muted)', fontSize: '0.758rem' }}>
                                    <th style={{ padding: '1rem' }}>TYPE</th>
                                    <th style={{ padding: '1rem' }}>DESTINATION</th>
                                    <th style={{ padding: '1rem' }}>DATE</th>
                                    <th style={{ padding: '1rem' }}>DURATION</th>
                                    <th style={{ padding: '1rem' }}>COST</th>
                                </tr>
                            </thead>
                            <tbody>
                                {calls.map((call, idx) => (
                                    <tr key={idx} style={{ borderBottom: '1px solid var(--border)' }}>
                                        <td style={{ padding: '1rem' }}>
                                            {call.direction === 'inbound' ? <FiPhoneIncoming color="var(--primary)" /> : <FiPhoneOutgoing color="var(--success)" />}
                                        </td>
                                        <td style={{ padding: '1rem', fontWeight: 600 }}>{call.to}</td>
                                        <td style={{ padding: '1rem', color: 'var(--text-muted)' }}>
                                            {new Date(call.createdAt).toLocaleDateString()}
                                        </td>
                                        <td style={{ padding: '1rem' }}>{call.duration}s</td>
                                        <td style={{ padding: '1rem', fontWeight: 600 }}>${call.cost?.toFixed(2) || '0.00'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CallHistory;
